import { toast } from "react-toastify";
import React, { useEffect, useState } from "react";
import Modal from "@/app/core/layouts/main/components/CustomModal";
import { Tab, Tabs } from "react-bootstrap";
import { UserHelper } from "@/app/core/util/helpers/UserHelper";
import { AccountController } from "@/app/core/base/controllers/AccountController";
import { Message } from "@/app/core/util/messages/GeralMessages";
import { ComplainController } from "@/app/core/base/controllers/ComplainController";
import { CompanyController } from "@/app/core/base/controllers/CompanyController";
import ComplainModal from "@/app/core/layouts/main-components/complain/ComplainModal";

export default function UserManagementModal({ show, onHide, user }) {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({});
  const [complains, setComplains] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selected, setSelected] = useState({});

  useEffect(() => {
    if (show && user && user.id) {
      setData(user);
      loadInfos();
    } else {
      setData({});
    }
  }, [show]);

  async function loadInfos() {
    let res = await ComplainController.ListByUser(user.id);
    for(let s of res){
      const response = await Promise.all([
          CompanyController.Get(s.companyId)
      ]);
      s.user = user;
      s.company = response[0];
  }
    setComplains(res);
  }

  async function save() { }

  async function changeUserLevel(evt) {
    let old = data;
    old.level = parseInt(evt.target.value);

    console.log("Itens ", old);

    await AccountController.Update(old);
    toast.success(Message.Saved);
    setData(old);
  }

  return (
    <Modal
      title="Usuário"
      show={show}
      onHide={onHide}
      isLoading={loading}
      onSubmit={() => save()}
    >
      <div className="block-content block-content-full text-center bg-body-light">
        <img
          className="img-avatar img-avatar-thumb"
          src={
            data && data.logo ? data.logo : "assets/media/avatars/avatar14.jpg"
          }
        />
        <div className="mt-2">
          <p className="font-w600 mb-0">{data && data.name}</p>
        </div>
      </div>
      <Tabs
        defaultActiveKey="resumo"
        id="uncontrolled-tab-example"
        className="mb-3"
      >
        <Tab eventKey="resumo" title="Resumo" className="block-content">
          <div className="form-group">
            <span>Email</span>
            <p>{data && data.email}</p>
          </div>
          <div className="form-group">
            <span>Telefone</span>
            <p>{data && data.phone}</p>
          </div>
          <div className="form-group">
            <span>CPF</span>
            <p>{data && data.doc}</p>
          </div>
          
          <div className="form-group">
            <span>Nível de acesso</span>
            <select className="form-control" name="level" onChange={evt => changeUserLevel(evt)}>
              {UserHelper.UserLevelList.map(item => (
                <option value={item.value} selected={data && data.level === item.value ? true : false}>{item.name}</option>
              ))}
            </select>
          </div>
        </Tab>
        <Tab
          eventKey="anuncios"
          title={complains && `(${complains.length}) Reclamações`}
        >
          <div className="list-group font-size-sm">
            {complains && complains.map(item => (
              <a className="list-group-item list-group-item-action" href="javascript:void(0)" onClick={() => setSelected(item) | setShowModal(true)}>
                {/* <span className="badge badge-pill badge-dark m-1 float-right">3</span> */}
                <p className="font-size-h6 font-w700 mb-0">
                  {item.title}
                </p>
                <p className="text-muted mb-2">
                  {item.description}
                </p>
                <p className="font-size-sm text-muted mb-0">
                  {/* <strong>{item.createdDate}</strong> */}
                </p>
              </a>
            ))}

          </div>
        </Tab>
      </Tabs>
      
      <ComplainModal
        show={showModal}
        onHide={()=> setShowModal(false) | loadInfos()}
        infos={selected && selected}/>
    </Modal>
  );
}
